<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <ContentOrLoading>
            <div class="row" v-if="evento && !loading">
                <div class="col-12 mb-3">
                    <label for="companies">Compañias (Seleccione una si desea autorellenar los campos de abajo con los de la compañia seleccionada)</label>
                    <multiselect
                        v-if="companies"
                        id="companies"
                        name="companies"
                        v-model="company"
                        placeholder="Compañias"
                        track-by="id"
                        label="nombre"
                        :options="companies"
                        :max-height="150"
                        @input="fillDatos()"
                    >
                        <template slot="noOptions">No hay compañias creadas.</template>
                    </multiselect>
                </div>
                <div class="col-12 col-lg-6">
                    <FormInput label="NIF*" type="text" name="nif" id="nif" rules="required" v-model="evento.nif_fiscal" />
                </div>
                <div class="col-12 col-lg-6">
                    <FormInput label="Nombre*" type="text" name="nombre" id="nombre" rules="required" v-model="evento.nombre_fiscal" />
                </div>
                <div class="col-12 col-lg-6">
                    <FormInput label="Dirección*" type="text" name="direccion" id="direccion" rules="required" v-model="evento.direccion_fiscal" />
                </div>
                <div class="col-12 col-lg-6">
                    <FormInput label="Ciudad*" type="text" name="ciudad" id="ciudad" rules="required" v-model="evento.ciudad_fiscal" />
                </div>
                <div class="col-12 col-lg-6">
                    <FormInput label="Código postal" type="number" name="código postal" id="cp" rules="required" v-model="evento.cp_fiscal" />
                </div>
                <div class="col-12 col-lg-6">
                    <FormInput label="Cuenta*" type="text" name="cuenta" id="cuenta" rules="required" v-model="evento.cuenta_fiscal" />
                </div>
                <div class="col-12 col-lg-6">
                    <FormInput label="IVA" type="number" name="iva" id="iva" rules="numeric" v-model="evento.iva" />
                </div>
                <div class="col-12 col-lg-6">
                    <FormInput label="IVA Autores" type="number" name="iva_autores" id="iva_autores" rules="numeric" v-model="evento.iva_autores" />
                </div>
                <div class="col-12 mt-4">
                    <h4>Contacto:</h4>
                    <hr/>
                </div>
                <div class="col-12 col-lg-6">
                    <FormInput label="Email de contacto*" type="email" name="Email de contacto" id="contact_email" rules="required|email" v-model="evento.contact_email" />
                </div>
                <div class="col-12 col-lg-6">
                    <FormInput label="Teléfono de contacto*" type="text" name="Teléfono de contacto" id="contact_telefono" rules="required" v-model="evento.contact_telefono" />
                </div>
                <div class="col-12">
                    <Button type="submit">Guardar</Button>
                </div>                        
            </div>
        </ContentOrLoading>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['evento'],
        data() {
            return {
                loading: true,
                companies: null,
                company: this.evento.company ?? null
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.guardar();
                }
            },
            getCompanies() {
                const params = {
                    filters : {
                        to_select: true
                    },
                    teatro_id: this.teatro.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.compania-eventos.index'), params).then(res => {
                    this.companies = res.data.data;
                    if (this.evento.teatro_company_id) {
                        this.company = this.companies.find(company => company.id === this.evento.teatro_company_id);
                        this.fillDatos();
                    }
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            guardar() {
                const data = {
                    nif_fiscal: this.evento.nif_fiscal,
                    nombre_fiscal: this.evento.nombre_fiscal,
                    direccion_fiscal: this.evento.direccion_fiscal,
                    cuenta_fiscal: this.evento.cuenta_fiscal,
                    evento_id: this.evento.id,
                    contact_email: this.evento.contact_email,
                    contact_telefono: this.evento.contact_telefono,
                    cp_fiscal: this.evento.cp_fiscal,
                    ciudad_fiscal: this.evento.ciudad_fiscal
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.editar.datos-fiscales'), data).then(res => {
                    this.$toast.success(res.data.message);
                    this.actualizar();
                }).catch(error => {
                    console.log(error);
                    this.loading = false;
                });
            },
            fillDatos() {
                if (this.company) {
                    if (!this.evento.teatro_company_id || this.evento.teatro_company_id !== this.company.id) {
                        const data = {
                            evento_id: this.evento.id,
                            teatro_company_id: this.company.id,
                            productos: 0
                        };

                        this.$store.dispatch(this.config.getVuexAlias('back.events.companies.desvincular'), {evento_id: this.evento.id, filters: { productos: 0 } })
                            .then(() => {
                                return this.$store.dispatch(this.config.getVuexAlias('back.events.companies.vincular'), data);
                            })
                            .then(res => {
                                this.$toast.success(res.data.message);
                                this.actualizar();
                            })
                            .catch(error => {
                                console.log(error);
                                this.loading = false;
                            });
                    }
                } else {
                    const data = {
                        evento_id: this.evento.id,
                        filters: {
                            productos: 0
                        }
                    };

                    this.$store.dispatch(this.config.getVuexAlias('back.events.companies.desvincular'), data).then(res => {
                        this.$toast.success(res.data.message);
                        this.evento.nif_fiscal = '';
                        this.evento.nombre_fiscal = '';
                        this.evento.direccion_fiscal = '';
                        this.evento.ciudad_fiscal = '';
                        this.evento.cp_fiscal = '';
                        this.evento.cuenta_fiscal = '';
                        this.evento.iva = '';
                        this.evento.iva_autores = '';
                        this.actualizar();
                    }).catch(error => {
                        console.log(error);
                        this.loading = false;
                    });
                }
            },
            actualizar() {
                this.$emit('actualizado');
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        created() {
            this.getCompanies();   
        }
    }
</script>